export default __webpack_public_path__ + "assets/icons/home_lijichadan.63a7e808.svg";